import React from 'react'
import { useTranslation } from 'react-i18next'

export default function LanguageToggle({ className = '' }) {

  const { i18n } = useTranslation()
  const isEnglish = i18n.language?.startsWith('en')

  const toggleLanguage = () => {
    const next = isEnglish ? 'es' : 'en'
    i18n.changeLanguage(next)
    try {
      localStorage.setItem('vt-lang', next)
    } catch (error) {
      // localStorage unavailable, language preference just won't persist
    }
  }

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={isEnglish ? 'Cambiar a español' : 'Switch to English'}
      className={`inline-flex items-center rounded-md border border-gray-300 px-3 py-1.5 text-sm font-semibold text-gray-600 transition hover:border-electric-600 hover:text-electric-600 ${className}`}
    >
      {isEnglish ? 'ESP' : 'ENG'}
    </button>
  )
}
